import axios from 'axios';
import axiosInstance from './AxiosService';

const userService = {
  fetchUsers: async () => {
    const response = await axiosInstance.get(`users/`);
    return response.data;
  },

  fetchCurrentUser: async () => {
    const response = await axiosInstance.get(`current_user/`);
    return response.data;
  },

  fetchUsersById: async (userId) => {
    const response = await axiosInstance.get(`users/${userId}/`);
    return response.data;
  },

  createUser: async (userDataWithRoles) => {
    const response = await axiosInstance.post(`users/`, userDataWithRoles);
    return response.data;
  }, 

  updateUser: async (username, userData) => {
    // URL encode the username to handle special characters like @ in email addresses
    const encodedUsername = encodeURIComponent(username);
    console.log(`Sending API request to users/${encodedUsername}/ with data:`, userData);
    const response = await axiosInstance.put(`users/${encodedUsername}/`, userData);
    return response.data;
  },
  
  updateUserById: async (userId, userData) => {
    console.log(`Sending API request to users/${userId}/ with data:`, userData);
    const response = await axiosInstance.put(`users/${userId}/`, userData);
    return response.data;
  },

  // New function specifically for our new endpoint that is guaranteed to use ID lookup
  updateUserByNumericId: async (userId, userData) => {
    console.log(`Sending API request to users/by-id/${userId}/ with data:`, userData);
    const response = await axiosInstance.put(`users/by-id/${userId}/`, userData);
    return response.data;
  },

  deleteUser: async (userId) => {
    const response = await axiosInstance.delete(`users/${userId}/`);
    return response.data;
  }
};

export default userService;
